import i18next from "i18next"
import { EnumGender, EnumStatus, EnumTypeTa, ModeUI, TransactionStatus, TypeTransaction, UserRole } from "./enum"

export const DATE_FORMAT = "MMM DD YYYY, HH:mm:ss"
export const LIMIT_PAGINATE = 30
export const LIST_ENTEIES = [30, 50, 100]

export interface IDropdown {
    label: string
    value: any
}

export const ListUserRoles = (): IDropdown[] => ([
    // {
    //     label: i18next.t("role.superadmin"),
    //     value: UserRole.SUPERADMIN
    // },
    {
        label: i18next.t("role.admin"),
        value: UserRole.ADMIN
    },
    {
        label: i18next.t("role.user"),
        value: UserRole.USER
    },
    {
        label: i18next.t("role.viewonly"),
        value: UserRole.VIEWONLY
    }
])

export const AllUserRoles = (): IDropdown[] => ([
    {
        label: i18next.t("role.superadmin"),
        value: UserRole.SUPERADMIN
    },
    {
        label: i18next.t("role.admin"),
        value: UserRole.ADMIN
    },
    {
        label: i18next.t("role.user"),
        value: UserRole.USER
    },
    {
        label: i18next.t("role.viewonly"),
        value: UserRole.VIEWONLY
    }
])

export const PermissionsUserRoles = (): IDropdown[] => ([
    {
        label: i18next.t("role.admin"),
        value: UserRole.ADMIN
    },
    {
        label: i18next.t("role.user"),
        value: UserRole.USER
    },
    {
        label: i18next.t("role.viewonly"),
        value: UserRole.VIEWONLY
    }
])

export const UserStatus = (status: boolean) => status ? i18next.t("user.active") : i18next.t("user.inactive")
export const ListStatus = (): IDropdown[] => ([
    {
        label: i18next.t("user.inactive"),
        value: Boolean(EnumStatus.INAVTIVE)
    },
    {
        label: i18next.t("user.active"), 
        value: Boolean(EnumStatus.ACTIVE)
    }
])
export const StatusApi = "fulfilled"
export const ListTypeTransaction = ():IDropdown[] => ([
    {
        label: i18next.t("transaction.deposit"),
        value: TypeTransaction.DEPOSIT
    },
    {
        label: i18next.t("transaction.withdraw"),
        value: TypeTransaction.WITHDRAW
    }
])
export const ListModeUI = () => ([
    {
        label: i18next.t("mode.light"),
        icon: "fa-light fa-brightness fa-lg",
        value: ModeUI.LIGHT
    },
    {
        label: i18next.t("mode.dark"),
        icon: "fa-light fa-moon-stars fa-lg",
        value: ModeUI.DARK
    },
    {
        label: i18next.t("mode.system"),
        icon: "fa-light fa-display fa-lg",
        value: ModeUI.AUTO
    }
])
export const ListTransactionStatus = ():IDropdown[] => ([
    {
        label: i18next.t("transaction.without_receive"),
        value: TransactionStatus.WITHOUT_RECEIVE
    },
    {
        label: i18next.t("transaction.finish"),
        value: TransactionStatus.FINISH
    },
    {
        label: i18next.t("transaction.canceled"),
        value: TransactionStatus.CANCLED
    }
])

export const ListGender = ():IDropdown[] => ([
    {
        label: i18next.t("form.male"),
        value: EnumGender.MALE
    },
    {
        label: i18next.t("form.female"),
        value: EnumGender.FEMALE
    }
])

export const ListTypeTa = ():IDropdown[] => ([
    {
        label: i18next.t("tenant.sc"),
        value: EnumTypeTa.SC
    },
    {
        label: i18next.t("tenant.spr"),
        value: EnumTypeTa.SPR
    },
    {
        label: i18next.t("tenant.normal"),
        value: EnumTypeTa.NORMAL
    },
    {
        label: i18next.t("tenant.other"),
        value: EnumTypeTa.OTHER
    }
])

export const ItemDropDownNone = () => ({
    label: i18next.t("form.none"),
    value: ""
})

export const ItemBusenissUnitDropDownNone = () => ({
    label: i18next.t("form.none"),
    value: "none"
})

export const ItemDropDownAll = () => ({
    label: i18next.t("form.all"),
    value: "all"
})

export const ItemBusinessUnitAll = () => ({
    label: i18next.t("dashboard.all_business_unit"),
    value: ""
})

export const DataStatusRental = (): IDropdown[] => ([
    {
        label: i18next.t("rental.will_rent"),
        value: "4"
    },
    {
        label: i18next.t("rental.type_renew"),
        value: "3"
    },
    {
        label: i18next.t("rental.ongoing"),
        value: "2"
    },
    {
        label: i18next.t("rental.expired"),
        value: "1"
    }
])

export const DataYears = () => {
    const currentYear = new Date().getFullYear()
    const years = [{
        label: "All Years",
        value: ""
    }]
    for (let i = 0; i <= currentYear - 2020; i++) {
        years.push({
            label: `${currentYear - i}`,
            value: `${currentYear - i}`
        })
    }
    return years
}

export const uuidNull = '00000000-0000-0000-0000-000000000000'